import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexDirection from './FlexDirection';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexDirection, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/flexbox/demos/flex-direction/FlexDirection.tsx",
    "fileName": "FlexDirection.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexDirection() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'row',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'row-reverse',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'flex-start',\n          flexDirection: 'column',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'column-reverse',\n          alignItems: 'flex-start',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 95,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexDirection() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'row',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'row-reverse',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          alignItems: 'flex-start',\n          flexDirection: 'column',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexDirection: 'column-reverse',\n          alignItems: 'flex-start',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 95,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
